import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { contentReader } from "@/lib/content.server";
import { localeSchema } from "@/lib/i18n/locale";

const languageInput = z.object({ locale: localeSchema });
const detailInput = languageInput.extend({ slug: z.string().min(1) });
const getPosts = createServerFn({ method: "GET" })
	.inputValidator(languageInput)
	.handler(({ data }) => contentReader.readPosts(data.locale));
const getPostDetails = createServerFn({ method: "GET" })
	.inputValidator(detailInput)
	.handler(({ data }) => contentReader.readPost(data.slug, data.locale));
const getDocs = createServerFn({ method: "GET" })
	.inputValidator(languageInput)
	.handler(({ data }) => contentReader.readDocs(data.locale));
const getDoc = createServerFn({ method: "GET" })
	.inputValidator(detailInput)
	.handler(({ data }) => contentReader.readDoc(data.slug, data.locale));
export const content = { getPosts, getPostDetails, getDocs, getDoc };
